/**
 * A "click outside" event handler that Unbinds itself once it's
 * triggered. Adding an event handler on all document click
 * events can harm performance, so this allows you to only ever
 * have the event listener bound while it's needed
 */
export function addOutsideClickListener(element, handler) {
  function listener(event) {
    if (!element.contains(event.target)) {
      handler()
      document.removeEventListener('click', listener)
    }
  }

  document.addEventListener('click', listener)
}

/**
 * Scroll to an element smoothly using requestAnimationFrame API.
 */
export function scrollToElement(element, duration = 400, topSpace = 0) {
  if (!element || !(element instanceof Element)) {
    console.warn(
      'A valid DOM element was not provided in order to perform page scrolling. scrollToElement did not complete.'
    )
  }

  const startingY = window.pageYOffset + topSpace
  const elementY = startingY + element.getBoundingClientRect().top
  const distance = elementY - startingY
  let start

  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    const elapsedTime = timestamp - start
    const percent = Math.min(elapsedTime / duration, 1)

    window.scrollTo(0, startingY + distance * percent)

    if (elapsedTime < duration) {
      window.requestAnimationFrame(step)
    }
  })
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
